export default {
  getList(state) {
    return state.list;
  },
  getPageInfo(state) {
    return state.pageInfo;
  },
  getCondition(state) {
    return state.condition;
  },
  getTotalPoint(state) {
    return state.totalPoint;
  }
};
